import React, { useContext } from "react"
import { SpaceProfileContext } from "../context"
// import * as styles from "./TimePicker.module.less"

const styles = {}

const Step2 = () => {
  const {
    commonData: { availableContextTimes, contextTime },
    actions: { setContextTime, setBookTour, setBookTourStep },
  } = useContext(SpaceProfileContext)

  return (
    <div className={styles.time_picker_wrapper}>
      <h5>What time works best?</h5>
      {availableContextTimes && availableContextTimes.length > 0 ? (
        <div className={styles.time_picker_wrapper_overflow}>
          <ul className={"times"}>
            {availableContextTimes.map((t) => (
              <li
                key={t}
                onClick={() => {
                  setContextTime(t)
                  setBookTourStep(3)
                }}
                className={contextTime === t ? "active" : ""}
              >
                {t}
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <p>No timeslots available.</p>
      )}
      <button
        className="btn btn-link px-0"
        onClick={() => {
          setBookTourStep(1)
          setContextTime(null)
        }}
      >
        Back
      </button>
    </div>
  )
}

export default Step2
